<template>
  <div>
    <section class="homepage-content hero is-home-banner is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title-font-open-sans">
            <!-- Fixing society by decentralizing education through an open internet -->
            <div>Fixing society by</div>
            <div>decentralizing education through</div>
            <div>an open internet</div>
          </h1>
          <br />
          <div class="">
            <h2 class="subtitle ">
              Flow broadens the spectrum of opportunities leading you build a
              fulfilling and successful career.
              <!-- <div>
                Flow broadens the spectrum of opportunities leading to a
                fulfilling career.
              </div>
              <div>
                Flow helps you build unique credentials, expanding awareness and
                inspiring peers through our crowd-sourced curation engine.
              </div> -->
            </h2>
          </div>
        </div>
        <br />
        <b-field class="action-buttom" position="is-centered">
          <b-button outlined type="is-secondary">
            <a
              target="_blank"
              href="https://www.facebook.com/groups/Flow.makemeflow"
            >
              Join Flow
            </a>
          </b-button>
        </b-field>
      </div>

      <div>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    // particlesJS
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}

@media only screen and (min-width: 200px) and (max-width: 767px) {
  .title-font-open-sans {
    font-size: 2rem !important;
  }
  .subtitle-font-open-sans {
    font-size: medium !important;
  }
}

.title-font-open-sans {
  font-weight: 700;
  font-size: 3rem;
}
.subtitle-font-open-sans {
  font-weight: 200;
  font-size: medium;
  // width: 50%;
}

a {
  color: #041434;
}
a:hover {
  color: #041434aa;
}

.waves {
  position: relative;
  width: 100%;
  height: 15vh;
  margin-bottom: -7px;
  min-height: 100px;
  max-height: 150px;
}

.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height: 40px;
    min-height: 40px;
  }
}
</style>
